import React from 'react'

const Copyright = () => {
  return (
    <div id='copyright'>
      Made by{' '}
      <a
        className='copyright__link'
        href='https://github.com/hoehooiyan/random-quote-machine'
        target='_blank'
        rel='noopener noreferrer'>
        Hooi Yan
      </a>
    </div>
  )
}

export default Copyright
